import { render, staticRenderFns } from "./FinanceiroDashboard.vue?vue&type=template&id=795d74ee&scoped=true"
import script from "./FinanceiroDashboard.vue?vue&type=script&lang=js"
export * from "./FinanceiroDashboard.vue?vue&type=script&lang=js"
import style0 from "./FinanceiroDashboard.vue?vue&type=style&index=0&id=795d74ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795d74ee",
  null
  
)

export default component.exports